/* global fetch, URL*/
export class OauthError {
  constructor(code) {
    this.code = code;
    this.redirecting = false;
  }
}

export class Oauth {
  constructor(myConfig) {
    this.configuration = myConfig;
    this.user = null;
    this.bearerTokenPromise = null;
    this.tokenTimer = null;
    this.meTimer = null;
    this.lastMeCheck = null;
  }

  async getMe() {
    this.meCheckIsDone();
    const response = await fetch(this.configuration.oauth.me, {
      method: 'GET',
      cache: 'no-cache',
      credentials: "include"
    });

    if(response.ok) {
      const newUser = await response.json();
      if(newUser.uuid !== this.user) {
        console.log('[ouath interceptor] Another user is logged in than the current one!');
        this.refreshBearerToken();
        if(this.configuration.onUserChanged) {
          this.configuration.onUserChanged(newUser);
        }
      }
      this.setUser(newUser.uuid);
    } else if(response.status === 403) {
      console.log('[oauth interceptor] /me returened 403 => there is no user logged in');
      this.setUser('NONE');
      this.redirectToLogin();
    } else {
      console.error('[oauth interceptor] /me call failed', response);
      throw new OauthError('/me call failed');
    }
  }

  setUser(userKey) {
    this.user = userKey;
    // check every 15 minutes if the current user is still logged in.
    if(this.meTimer) {
      clearTimeout(this.meTimer);
    }
    this.meTimer = setInterval(() => {
      if (!this.lastMeCheck || (new Date()).getTime() - this.lastMeCheck.getTime() > 900000) {
        console.log('[ouath interceptor] checking if current user is still valid...');
        this.getMe();
      }
    }, 12500);
  }

  meCheckIsDone() {
    this.lastMeCheck = new Date();
  }

  redirectToLogin() {
    if(this.configuration.onLoggedOut) {
      this.configuration.onLoggedOut();
    } else {
      const redirectTo = this.configuration.oauth.authenticate
            + '?scope=' + this.configuration.oauth.scope
            + '&response_type=none&client_id=' + this.configuration.oauth.clientID
            + '&redirect_uri=' + this.configuration.oauth.redirectUri
            + '&state=' + encodeURIComponent(window.location.href);
      window.location.href = redirectTo;
    }
  }

  async authenticateForToken() {
    if(!this.user) {
      // console.log('[oauth interceptor] The user is not logged in yet. It is not usefull to do /authenticate for a token');
      // throw new OauthError('redirected.to.login.page');
      console.log('[oauth interceptor] We do not know the user, oauth interceptor will do a /me himself.');
      await this.getMe();
    }
    if (!this.user || this.user === 'NONE') {
      throw new OauthError('user.not.logged.in');
    }
    const data = {
      client_id: this.configuration.oauth.clientID,
      redirect_uri: this.configuration.oauth.redirectUri,
      response_type: 'token',
      scope: this.configuration.oauth.scope
    };
    const url = new URL(this.configuration.oauth.authenticate);
    Object.keys(data).forEach(key => url.searchParams.append(key, data[key]));
    const response = await fetch(url, {
      method: 'GET',
      cache: 'no-cache',
      credentials: "include",
      redirect: "follow"
    });

    if(response.ok) {
      const contentType = response.headers.get('content-type');
      if(contentType.match(/text\/html/)) {
        throw new OauthError('redirected.to.login.page');
      } else if(contentType.match(/application\/json/)) {
        const resp = await response.json();
        return {
          value: resp.access_token,
          expiresIn: resp.expires_in
        };
      } else {
        throw new OauthError('unexpected.content.type');
      }
    } else {
      console.error('[oauth interceptor] /authenticate call failed', response);
      throw new OauthError('/authenticate call failed');
    }
  }

  /*
  Flow to get the tocken with POST /token but this needs a client secret which we dont have for a good reason:
  with a refresh token you never need to log in again and do infinite requests.
  async getToken() {
    const authenticateData = {
      client_id: this.configuration.oauth.clientID,
      redirect_uri: this.configuration.oauth.redirectUri,
      response_type: 'code',
      scope: this.configuration.oauth.scope
    };
    const authenticateUrl = new URL(this.configuration.oauth.authenticate);
    Object.keys(authenticateData).forEach(key => authenticateUrl.searchParams.append(key, authenticateData[key]));
    const authenticateResponse = await fetch(authenticateUrl, {
      method: 'GET',
      cache: 'no-cache',
      credentials: "include",
      redirect: "follow"
    });
    if(authenticateResponse.ok) {
      const authenticateContentType = authenticateResponse.headers.get('content-type');
      if(authenticateContentType.match(/text\/html/)) {
        throw new OauthError('redirected.to.login.page');
      } else if(authenticateContentType.match(/application\/json/)) {
        const authenticateResp = await authenticateResponse.json();
        console.log('authenticateResp', authenticateResp);

        let formData = new URLSearchParams();
        formData.append('client_id', this.configuration.oauth.clientID);
        formData.append('grant_type', 'authorization_code');
        formData.append('redirect_uri', this.configuration.oauth.redirectUri);
        formData.append('code', authenticateResp.code);
        const tokenUrl = new URL(this.configuration.oauth.token);
        const tokenResponse = await fetch(tokenUrl, {
          method: 'POST',
          body: formData.toString(),
          headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'},
          cache: 'no-cache',
          credentials: "include",
          redirect: "follow"
        });
        if(tokenResponse.ok) {
          const tokenResp = tokenResponse.json();
          console.log('tokenResp', tokenResp);
        } else {
          throw new OauthError('POST /token failed');
        }
      } else {
        throw new OauthError('unexpected.content.type');
      }
    } else {
      throw new OauthError('authenticate for code failed');
    }
  }*/

  async refreshBearerToken() {
    try {
      this.bearerTokenPromise = this.authenticateForToken();
      const bearerToken = await this.bearerTokenPromise;
      if(this.tokenTimer) {
        clearTimeout(this.tokenTimer);
      }
      this.tokenTimer = setTimeout(() => {
        console.log('[ouath interceptor] token expired, we will automatically refresh it');
        this.refreshBearerToken();
      }, bearerToken.expiresIn*1000);
      if(!this.user) {
        console.log('[oauth interceptor] Still no /me done, so I dont know the user. I will fetch it myself. Matthias does not think we can come here because how can you ask a bearer token successfull if you are not logged in');
        this.getMe();
      }
    } catch (error) {
      this.bearerTokenPromise = null;
      if (error instanceof OauthError && (error.code === 'redirected.to.login.page' || error.code === 'user.not.logged.in')) {
        // a scenario that can be expected, we will just throw the error to the method above which will handle this error
        throw error;
      }
      console.error('[oauth interceptor] Unexpected Problem with authenticating: ', error);
      throw error;
    }
  }

  async getBearerToken() {
    if(!this.bearerTokenPromise) {
      console.log('[oauth interceptor] There is no bearer token yet. We will try fetching one...');
      await this.refreshBearerToken();
    }
    return this.bearerTokenPromise;
  }

  setBearerToken(value, expiresIn) {
    if(this.tokenTimer) {
      clearTimeout(this.tokenTimer);
    }
    this.bearerTokenPromise = Promise.resolve({
      value,
      expiresIn
    });
    this.tokenTimer = setTimeout(() => {
      this.refreshBearerToken();
    }, expiresIn*1000);
  }

  invalidateBearerToken() {
    this.bearerTokenPromise = null;
  }
}
